import React from "react"
import { GLOBAL_APPLICATION_INTERNAL_LINKS } from "@links";
import logo from "@images/blog/bw-logo.svg"
import { useFooterConfiguration } from "../../hooks"
import { ProudSection } from "./components"
import {
  StyledFooterWrapper,
  StyledLogoIconContainer,
  StyledLogoIcon,
  StyledNavigationalLinksWrapper,
  StyledAboutCompanyWrapper,
  StyledCopyrightWarning,
  StyledSocialMediaContainer,
  StyledFooterContainer,
  StyledAboutCompanyContainer,
  StyledCompanyRulesContainer,
  StyledPrivacyPolicy,
  StyledGDPR,
  StyledInternalLink
} from "./styled"

const Footer = () => {
  const { isMobile, navigationalItems, socialMedias, currentYear } = useFooterConfiguration()
  return (
    <StyledFooterWrapper>
      <StyledFooterContainer>
        <StyledLogoIconContainer>
          <StyledLogoIcon src={logo} />
        </StyledLogoIconContainer>
        <ProudSection />
      </StyledFooterContainer>
      <StyledNavigationalLinksWrapper>
        {navigationalItems}
      </StyledNavigationalLinksWrapper>
      <StyledAboutCompanyWrapper>
        <StyledSocialMediaContainer>{socialMedias}</StyledSocialMediaContainer>
        <StyledAboutCompanyContainer>
          <StyledCompanyRulesContainer>
            <StyledInternalLink to={GLOBAL_APPLICATION_INTERNAL_LINKS.COOKIE_POLICY}>
              <StyledPrivacyPolicy>Cookies Policy</StyledPrivacyPolicy>
            </StyledInternalLink>
            <StyledInternalLink to={GLOBAL_APPLICATION_INTERNAL_LINKS.PRIVACY_POLICY}>
            <StyledPrivacyPolicy>Privacy policy</StyledPrivacyPolicy>
            </StyledInternalLink>
            <StyledInternalLink to={GLOBAL_APPLICATION_INTERNAL_LINKS.GDPR}>
            <StyledGDPR>GDPR</StyledGDPR>
            </StyledInternalLink>
          </StyledCompanyRulesContainer>
        <StyledCopyrightWarning>
          Copyright © 2018-{currentYear} Impressit.
          {isMobile && <br />}&nbsp; All rights reserved.
        </StyledCopyrightWarning>
        </StyledAboutCompanyContainer>
      </StyledAboutCompanyWrapper>
    </StyledFooterWrapper>
  )
}

export default Footer
